import { FC } from 'react';

const Placeholder: FC = () => {
  return (
    <div className='placeholder-wrapper'>
      <h2>turn your</h2>
      <h1>logo</h1>
      <h2>into neon</h2>
      <h3>Just fill out the form and upload your image</h3>
    </div>
  );
};

export default Placeholder;
